import * as React from 'react';
import { useAuth, type CockpitRole } from '@/auth/AuthProvider';

export function RoleGate({
  allow,
  children,
  fallback,
}: {
  allow: readonly CockpitRole[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}): JSX.Element {
  const { principal } = useAuth();
  const allowed = principal?.roles.some((role) => allow.includes(role)) ?? false;
  if (!allowed) {
    return (
      <div className="rounded-md border border-dashed p-6 text-sm text-muted-foreground">
        {fallback ?? `Your role does not have access to this surface. Required: ${allow.join(' or ')}.`}
      </div>
    );
  }
  return <>{children}</>;
}
